<template>
  <div id="thematicServices" class="thematic-services" v-if="data && data.length>0">
    <HomeTitle :data="titleData" @moreHandle="moreHandle"></HomeTitle>
    <div class="service-container">
      <div class="service-box" v-for="(item, index) in data" :key="index" @click="serviceHandle(item)">
        <span class="iconbox">
            <img
                class="icon-img"
                onload="SVGInject(this)"
                round fit="cover"
                :src="complete(item.speciaIcon)"
            />
        </span>
        <p class="service-name">{{ item.speciaName }}</p>
        <p class="service-describe">{{ item.speciaSub }}</p>
        <img class="graphics graphics01" src="../../assets/image/home/graphics01.png" alt="">
        <img class="graphics graphics02" src="../../assets/image/home/graphics02.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import {complete, baseURL} from "@/utils/url"
import * as svg from '@/utils/svg-inject.min'
import { getThematicService } from '@/api/home/index'
export default {
  name: "ThematicServices",
  components: {
    HomeTitle: () => import('./HomeTitle')
  },
  props:[ 'title' ],
  data() {
    return {
      titleData: {
        title: this.title,
        more: true
      },
      basePath: baseURL,
      data: [],
    }
  },
  created() {
    this.getThematicServiceList();
  },
  methods: {
    complete,
    // 获取服务列表
    getThematicServiceList() {
      let params = { pageIndex: 0, pageSize: 3, useType: 2 }
      getThematicService(params).then(res => {
        if (res && res.code == 200) {
          this.data = res.data.data;
        }
      })
    },
    // 更多点击事件
    moreHandle() {
      this.$router.push('/project');
    },
    // 专题服务点击事件
    serviceHandle(item) {
      this.$router.push('/project/details/'+item.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme/theme.scss';
.service-container {
  padding: 15px 0;
  display: flex;

  .service-box {
    position: relative;
    width: 107px;
    height: 130px;
    padding: 20px 10px;
    margin-right: 12px;
    box-sizing: border-box;
    border-radius: 5px;
    color: #fff;
    text-align: center;
    background: var(--main-color);
    box-shadow: 0 0 8px 0 rgba(25, 137, 250, .1);
    flex-shrink: 0;
    &:last-of-type{
      margin:0;
    }
    .iconbox {
      display: block;
      width: 24px;
      height: 24px;
      margin: 0 auto 15px;

      img,svg {
        display: block;
        width: 24px;
        height: 24px;
        fill: #fff;
      }
    }

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.service-name {
        height: 25px;
        line-height: 25px;
        @extend .font16;
      }

      &.service-describe {
        height: 23px;
        line-height: 23px;
        @extend .font13;
      }
    }

    .graphics {
      position: absolute;
      bottom: 0;
      width: 100%;
    }

    .graphics01 {
      left: 0;
      -webkit-animation: project-animation01 5s linear infinite;
      -o-animation: project-animation01 5s linear infinite;
      animation: project-animation01 5s linear infinite;
    }

    .graphics02 {
      right: 0;
      -webkit-animation: project-animation02 5s linear infinite;
      -o-animation: project-animation02 5s linear infinite;
      animation: project-animation02 5s linear infinite;
    }

    @keyframes project-animation01 {
      0%,100% {
        -webkit-transform: translate(0, 0);
        -moz-transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -o-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      50% {
        -webkit-transform: translate(0, 10px);
        -moz-transform: translate(0, 10px);
        -ms-transform: translate(0, 10px);
        -o-transform: translate(0, 10px);
        transform: translate(0, 10px);
      }
    }

    @keyframes project-animation02 {
      0%,100% {
        -webkit-transform: translate(0, 0);
        -moz-transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -o-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      50% {
        -webkit-transform: translate(20px, 10px);
        -moz-transform: translate(20px, 10px);
        -ms-transform: translate(20px, 10px);
        -o-transform: translate(20px, 10px);
        transform: translate(20px, 10px);
      }
    }
  }
}
</style>
